<div class="logo">
    <a href="/" class="simple-text">
        xgame
    </a>
</div>
<div class="sidebar-wrapper">
    <ul class="nav">
        <li routerLinkActive="active" *ngFor="let menuItem of menuItems" class="{{menuItem.class}} nav-item">
            <a class="nav-link" [routerLink]="[menuItem.path]">
                <i class="material-icons">{{menuItem.icon}}</i>
                <p>{{menuItem.title}}</p>
            </a>
        </li>

        <li *ngIf="isMobileMenu()" class="nav-item logout">
            <a class="nav-link" href="javascript:void(0)" (click)="logout()">
            <i class="material-icons">logout</i>
                <p>Logout</p>
           </a>
        </li>
    </ul>
</div>
